/**
 * Path utility functions for file and folder operations
 */

/**
 * Strips the first directory segment from a path
 *
 * @param path - The path to process
 * @returns The path with the first directory segment removed
 *
 * @example
 * stripFirstDirectory('folder/file.md') // returns 'file.md'
 * stripFirstDirectory('a/b/c/file.md') // returns 'b/c/file.md'
 * stripFirstDirectory('file.md') // returns 'file.md'
 */
export function stripFirstDirectory(path: string): string {
  const index = path.indexOf('/')
  return index === -1 ? path : path.slice(index + 1)
}
